import type { CityConfig } from "../city-template/types";

export const winstonSalemConfig: CityConfig = {
  city: "Winston-Salem",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "winston-salem",
  route: "/cities/winston-salem",
  title: "Emergency Passport Winston-Salem, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Winston-Salem, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Forsyth County and the Piedmont Triad. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Winston-Salem, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Winston-Salem and Piedmont Triad travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20view%20of%20Winston-Salem%20North%20Carolina%20skyline%20with%20modern%20downtown%20buildings%20and%20historic%20tobacco%20district%20warehouses%2C%20the%20Innovation%20Quarter%20visible%2C%20warm%20golden%20afternoon%20sunlight%20illuminating%20the%20city%2C%20lush%20green%20Piedmont%20landscape%20with%20rolling%20hills%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20natural%20green%20landscape%2C%20no%20text%20or%20signs%20on%20buildings%2C%20classic%20Southern%20city%20atmosphere&width=1800&height=700&seq=winston-salem-hero-nc-001&orientation=landscape",
  heroImageAlt: "Winston-Salem North Carolina skyline with historic tobacco district and downtown",
  geoPosition: "36.0999;-80.2442",
  geoPlacename: "Winston-Salem, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 300 miles from Winston-Salem via I-85",
  },
  nearbyCitiesZips: [
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Clemmons", zips: "27012" },
    { name: "Lewisville", zips: "27023" },
    { name: "King", zips: "27021" },
    { name: "Tobaccoville", zips: "27050" },
    { name: "Rural Hall", zips: "27045" },
    { name: "Walkertown", zips: "27051" },
    { name: "Pfafftown", zips: "27040" },
    { name: "Advance", zips: "27006" },
    { name: "Yadkinville", zips: "27055" },
    { name: "Mocksville", zips: "27028" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Winston-Salem departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Forsyth County Coverage", desc: "Serving Winston-Salem, Kernersville, and the entire Piedmont Triad" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Emergency passport help in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Urgent passport services in Asheville, NC", route: "/cities/asheville" },
    { name: "Same-day passport help in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
    { name: "Fast passport renewal in Kernersville, NC", route: "/cities/kernersville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Winston-Salem remotely via secure courier. We do not have a walk-in office in Winston-Salem — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Forsyth County and the Piedmont Triad travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Forsyth County and the Piedmont Triad including Yadkin and Davie counties",
  serviceAreaIntro: "From downtown Winston-Salem to the suburbs of Kernersville and Clemmons, from Lewisville to King and Rural Hall — Fast Passport Center serves the entire Winston-Salem metro area. We regularly help travelers from Walkertown, Tobaccoville, and Pfafftown get their passports fast.",
  nearbyCitiesIntro: "We serve all Winston-Salem neighborhoods and the surrounding Piedmont Triad area including Kernersville, Clemmons, Lewisville, King, Tobaccoville, Rural Hall, Walkertown, Pfafftown, Advance, Yadkinville, and Mocksville. If you are anywhere in Forsyth, Yadkin, or Davie counties, we have you covered.",
  howItWorksIntro: "Most Winston-Salem travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Winston-Salem travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Winston-Salem and Forsyth County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Winston-Salem? Here are the most common ones we hear from Forsyth County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Winston-Salem international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia W.",
      location: "Winston-Salem, NC",
      rating: 5,
      text: "My passport expired the week before our anniversary trip to Paris. Fast Passport Center had my renewal in 4 days. Never had to leave the Triad. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "James H.",
      location: "Kernersville, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Germany. Got it in 30 hours. The team was incredibly responsive and compassionate. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Laura B.",
      location: "Clemmons, NC",
      rating: 5,
      text: "Business trip to Tokyo came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "Michael T.",
      location: "Lewisville, NC",
      rating: 5,
      text: "First passport for my son before his mission trip to Kenya. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "ws-1",
      name: "Winston-Salem Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 631-5183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Winston-Salem",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Winston-Salem facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "ws-2",
      name: "Kernersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Mountain St",
      city: "Kernersville",
      state: "NC",
      zip: "27284",
      phone: "(336) 992-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Forsyth County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kernersville and eastern Forsyth County residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "ws-3",
      name: "Clemmons Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6364 Shallowford Rd",
      city: "Clemmons",
      state: "NC",
      zip: "27012",
      phone: "(336) 766-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Forsyth County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clemmons and Lewisville area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "ws-4",
      name: "King Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Dalton Rd",
      city: "King",
      state: "NC",
      zip: "27021",
      phone: "(336) 983-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Forsyth County, Stokes County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves King, Rural Hall, and Tobaccoville area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "ws-5",
      name: "Forsyth County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "200 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 779-6300",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Forsyth County Courthouse, downtown Winston-Salem",
      website: "https://www.forsyth.cc/",
      websiteLabel: "Forsyth County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "ws-6",
      name: "Walkertown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2921 Main St",
      city: "Walkertown",
      state: "NC",
      zip: "27051",
      phone: "(336) 595-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northeast Forsyth County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Walkertown and northeast Forsyth County area. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Winston-Salem photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Forsyth County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Winston-Salem applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Forsyth County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Winston-Salem travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Winston-Salem." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Winston-Salem address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Winston-Salem before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Winston-Salem for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Winston-Salem?", a: "Fast Passport Center offers fast passport renewal in Winston-Salem in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Winston-Salem?", a: "The nearest regional passport agency to Winston-Salem is the Atlanta Passport Agency, approximately 300 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Winston-Salem without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Winston-Salem?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5 hours from Winston-Salem — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Forsyth County residents." },
    { q: "Do you serve the entire Piedmont Triad from Winston-Salem?", a: "Absolutely. Fast Passport Center serves the entire Piedmont Triad from Winston-Salem including Kernersville, Clemmons, Lewisville, King, Tobaccoville, Rural Hall, Walkertown, Pfafftown, and Mocksville. Our courier service works seamlessly from any address in Forsyth, Yadkin, or Davie counties." },
    { q: "Can I expedite a child passport in Winston-Salem?", a: "Yes. Fast Passport Center expedites child passports in Winston-Salem for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Forsyth County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Winston-Salem with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Winston-Salem", address: "301 W 4th St, Winston-Salem, NC 27101", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Winston-Salem", address: "2600 Peters Creek Pkwy, Winston-Salem, NC 27127", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Winston-Salem", address: "4550 Kester Mill Rd, Winston-Salem, NC 27103", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Winston-Salem", address: "3280 Silas Creek Pkwy, Winston-Salem, NC 27103", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Kernersville", address: "120 E Mountain St, Kernersville, NC 27284", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Clemmons", address: "6361 Shallowford Rd, Clemmons, NC 27012", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Lewisville", address: "6530 Shallowford Rd, Lewisville, NC 27023", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — King", address: "1008 W King St, King, NC 27021", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Winston-Salem",
      address: "1100 S Stratford Rd, Winston-Salem, NC 27103",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Kernersville",
      address: "150 W Mountain St, Kernersville, NC 27284",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Clemmons",
      address: "6365 Shallowford Rd, Clemmons, NC 27012",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves west Forsyth County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — King",
      address: "1010 W King St, King, NC 27021",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Stokes and north Forsyth counties. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "25 miles east of downtown Winston-Salem",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport for the Piedmont Triad serving Winston-Salem, Greensboro, and High Point. Direct flights to major domestic hubs and seasonal international routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "INT",
      name: "Smith Reynolds Airport",
      distance: "3 miles northeast of downtown Winston-Salem",
      address: "3801 N Liberty St, Winston-Salem, NC 27105",
      note: "Regional airport for Winston-Salem with general aviation and limited commercial services.",
      flightUrl: "https://www.winstonsalem.com/",
      flightLabel: "INT Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "75 miles south of Winston-Salem",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from Winston-Salem.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Forsyth County Register of Deeds',
      description: 'Marriage licenses and records for Forsyth County. Apply in person or request certified copies.',
      url: 'https://www.forsyth.cc/rod/',
    },
    {
      label: 'Forsyth County Clerk of Superior Court',
      description: 'Divorce records and decrees for Forsyth County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/forsyth-county/forsyth-county-clerk-of-superior-court',
    },
  ],
};